export default __webpack_public_path__ + "static/media/wi-night-fog.4658561b.svg";